import getScrollbarWidth from './getScrollbarWidth'

let overflowCount = 0
let overflow = false

export function incrementOverflowCount(shouldScroll = true) {
  overflowCount++

  if (overflowCount > 0 && !overflow) {
    overflow = true
    document.body.style.paddingRight = `${getScrollbarWidth()}px`
    document.body.style.overflow = 'hidden'

    const style = window.getComputedStyle(document.body)
    const overflowStyle = style.getPropertyValue('overflow')
    const paddingRightStyle = style.getPropertyValue('padding-right')
  }
}

export function decrementOverflowCount() {
  overflowCount--

  if (overflowCount <= 0 && overflow) {
    overflow = false
    document.body.style.removeProperty('overflow')
    document.body.style.removeProperty('padding-right')
  }
}
